import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Product, rangePath } from '../data/mockData';
export function ProductCard({
  product,
  index = 0
}: {
  product: Product;
  index?: number;
}) {
  return <motion.article initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    delay: Math.min(index * 0.05, 0.3),
    ease: [0.23, 1, 0.32, 1]
  }} className="group" data-id="element-199" data-mp="fd8oksudlpvj">
      <Link to={`/product/${product.id}`} className="block" data-id="element-200" data-mp="tcrwbkj9yz7b">
        <div className="relative overflow-hidden rounded-3xl bg-paper-warm" data-id="element-201" data-mp="tb72jx4sbkai">
          <div className="aspect-[4/5] overflow-hidden" data-id="element-202" data-mp="ybuqg9xpvl0i">
            <img src={product.image} alt={product.name} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" data-id="element-203" data-mp="2v5677znej3e8" />
          </div>

          {product.badge && <span className="type-eyebrow absolute left-4 top-4 rounded-full bg-paper px-3 py-1.5 text-[9px] text-coffee" data-id="element-204" data-mp="3lsouzxy6wcck">
              {product.badge}
            </span>}

          <button onClick={e => e.preventDefault()} aria-label={`Quick add ${product.name}`} className="absolute bottom-4 right-4 flex h-11 w-11 translate-y-2 items-center justify-center rounded-full bg-coffee text-paper opacity-0 transition-[transform,opacity,background-color] duration-200 ease-out hover:bg-pennant group-hover:translate-y-0 group-hover:opacity-100" data-id="element-205" data-mp="3cyscqu85bk2f">
            <PlusIcon className="h-4 w-4" strokeWidth={2} data-id="element-206" data-mp="3qpxdjzn92iec" />
          </button>
        </div>
      </Link>

      <div className="mt-5 flex items-start justify-between gap-4" data-id="element-207" data-mp="2k9v4ljxnf3ne">
        <div className="min-w-0" data-id="element-208" data-mp="2kb68rkv0adf1">
          <Link to={rangePath({
          id: product.rangeId,
          kind: product.rangeKind
        })} className="type-eyebrow text-[9px] text-pennant hover:underline" data-id="element-209" data-mp="2fb1nzin2ewj0">
            {product.rangeName}
          </Link>
          <h3 className="type-display mt-1.5 truncate text-2xl text-coffee" data-id="element-210" data-mp="2lpz3wh5fzpi0">
            <Link to={`/product/${product.id}`} data-id="element-211" data-mp="27rsdtn6qitsw">{product.name}</Link>
          </h3>
          <p className="type-body mt-1 text-xs text-ink/50" data-id="element-212" data-mp="2cqc1bs0z8dnd">{product.size}</p>
        </div>
        <div className="shrink-0 text-right" data-id="element-213" data-mp="2cs6lh44fc1qe">
          <p className="type-ui text-sm text-coffee" data-id="element-214" data-mp="1y0eilrltgg5k">{product.price}</p>
          <div className="mt-2 flex justify-end gap-1.5" data-id="element-215" data-mp="22rwdbxx8xki3">
            {product.colorways.map(c => <span key={c} className="h-2.5 w-2.5 rounded-full ring-1 ring-inset ring-coffee/10" style={{
            backgroundColor: c
          }} data-id="element-216" data-mp="1p1azwoqka2rl" />)}
          </div>
        </div>
      </div>
    </motion.article>;
}